import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { Basket, BasketListResponse, BasketQueryParams, CreateBasket, UpdateBasket } from '@frontend/basket/types';

export class BasketClient extends APIClient {
    public static readonly endpoint = '/basket-api/v1';

    public static async fetchBaskets(queryParams?: ApiQueryParams<BasketQueryParams>): Promise<BasketListResponse> {
        return this.apiPaginated<BasketListResponse, BasketQueryParams>(`${this.endpoint}/baskets`, queryParams);
    }

    public static async fetchMyBaskets(queryParams?: ApiQueryParams<BasketQueryParams>): Promise<BasketListResponse> {
        return this.apiPaginated<BasketListResponse, BasketQueryParams>(`${this.endpoint}/my-baskets`, queryParams);
    }

    public static async resolveBaskets(ids: string[], field: string = 'id'): Promise<BasketListResponse> {
        return this.resolve<BasketListResponse>(`${this.endpoint}/baskets`, ids, field);
    }

    public static async deleteBaskets(ids: string): Promise<void> {
        const response = await this.post(`${this.endpoint}/baskets-delete`, { ids });
        return await this.handleVoidResponse(response);
    }

    public static async postBasket(accountId: string, basket: CreateBasket, withToken?: Token): Promise<Basket> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/baskets`, basket, true, withToken);
        return await this.handleResponse<Basket>(response);
    }

    public static async fetchBasket(accountId: string, basketId: string): Promise<Basket> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/baskets/${basketId}`);
        return await this.handleResponse<Basket>(response);
    }

    public static async patchBasket(accountId: string, basketId: string, basket: UpdateBasket): Promise<Basket> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/baskets/${basketId}`, basket);
        return await this.handleResponse<Basket>(response);
    }

    public static async deleteBasket(accountId: string, basketId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/baskets/${basketId}`);
        return await this.handleVoidResponse(response);
    }
}
